import React, { useState, FunctionComponent } from 'react';

import AssetAttachment, { FullAttachment } from './AssetAttachment';

import './styles/_asset_attachments_list.scss';

// not actually ts-defined Attachment because getting sent from server so getting full record
const AssetAttachmentsList: FunctionComponent<{ assetKey: string; attachments: FullAttachment[] }> = ({ assetKey, attachments }) => {
  const [selectedAttachmentId, setSelectedAttachmentId] = useState(attachments[0].id);
  const attachmentChildren = attachments.map((attachment) => (
    <AssetAttachment
      assetKey={assetKey}
      attachment={attachment}
      selectedAttachmentId={selectedAttachmentId}
      setSelectedAttachmentId={setSelectedAttachmentId}
    />
  ));

  return (
    <div className="asset-attachments__list">
      <div className="asset-attachments__list--title">
        <span className="bff-paperclip" />
        <h4 className="asset-attachments__list--title-count">{attachments.length}</h4>
        <h4>{attachments.length !== 1 ? t("Attachments") : t("Attachment")}</h4>
      </div>
      {attachmentChildren}
    </div>
  );
};

export default AssetAttachmentsList;
